import React, { useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import userContext from "../../UseContext/UseContext";
import { Nav, Collapse } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import brandLogo from "../../../Assets/Images/brand-logo.svg";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import PeopleIcon from "@mui/icons-material/People";
import "../Sidebar/Sidebar.scss";
import DashBoardIteams from "../../SidebarItems/DashBoardIteams";
import ProductsItems from "../../SidebarItems/ProductsItems";
import CouponItems from "../../SidebarItems/CouponItems";
import ShippingItems from "../../SidebarItems/ShippingItems";
import MasterItems from "../../SidebarItems/MasterItems";
import VendorItems from "../../SidebarItems/VendorItems";

const SidebarItem = ({ icon, text, link, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="text-decoration-none">
      <li
        onClick={() => setIsOpen(!isOpen)}
        aria-controls={text}
        aria-expanded={isOpen}
      >
        <div className="d-flex ">
          <span className="me-2">{icon} </span>
          <div className="sidebar-text text-center my-auto">{text}</div>
        </div>
        {isOpen ? (
          <IoIosArrowDown className="sidebar-menu-icon" />
        ) : (
          <IoIosArrowForward className="sidebar-menu-icon" />
        )}
      </li>

      <Collapse in={isOpen}>
        <div id={text}>{children}</div>
      </Collapse>
    </div>
  );
};

const Sidebar = ({ open }) => {
  const { id } = useParams();
  const { permissionvalues } = useContext(userContext);
  const permissionsData = permissionvalues?.permissions || {};
  const subdoamin = localStorage.getItem("vendorsubdomain");

  const hasAnyPermission = (section, subSection = null) => {
    if (!permissionsData[section]) return false;

    if (subSection) {
      const subsectionData = permissionsData[section][subSection];
      return (
        subsectionData?.create ||
        subsectionData?.edit ||
        subsectionData?.read ||
        subsectionData?.delete
      );
    }

    const sectionData = permissionsData[section];

    if (
      sectionData.create ||
      sectionData.edit ||
      sectionData.read ||
      sectionData.delete
    ) {
      return true;
    }

    if (typeof sectionData === "object") {
      return Object.values(sectionData).some(
        (perm) => perm?.create || perm?.edit || perm?.read || perm?.delete
      );
    }

    return false;
  };

  return (
    <div className={open ? "sidebar active" : "sidebar"}>
      <div className="sidebar-logo">
        <Link to={id ? `/${id}/dashboard` : "/"}>
          <img src={brandLogo} alt="Brand Logo" />
        </Link>
      </div>

      <Nav className="flex-column sidebar-items">
        {subdoamin === id ? (
          <>
            {hasAnyPermission("dashboard") && (
              <SidebarItem
                icon={<DashboardIcon className="sidebar-icon" />}
                text="Dashboard"
              >
                {permissionsData.dashboard.dashboard &&
                  (permissionsData.dashboard.dashboard.create ||
                    permissionsData.dashboard.dashboard.edit ||
                    permissionsData.dashboard.dashboard.read ||
                    permissionsData.dashboard.dashboard.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`/${subdoamin}/dashboard`}
                    >
                      <li className="mx-2">Main Dashboard</li>
                    </Link>
                  )}

                {permissionsData.dashboard.enquiry &&
                  (permissionsData.dashboard.enquiry.create ||
                    permissionsData.dashboard.enquiry.edit ||
                    permissionsData.dashboard.enquiry.read ||
                    permissionsData.dashboard.enquiry.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`/${subdoamin}/dashboard/enquiry`}
                    >
                      <li className="mx-2">Enquiries</li>
                    </Link>
                  )}
                {permissionsData.dashboard.user &&
                  (permissionsData.dashboard.user.create ||
                    permissionsData.dashboard.user.edit ||
                    permissionsData.dashboard.user.read ||
                    permissionsData.dashboard.user.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`/${subdoamin}/dashboard/user`}
                    >
                      <li className="mx-2">Users</li>
                    </Link>
                  )}
                {permissionsData.dashboard.totalOrder &&
                  (permissionsData.dashboard.totalOrder.create ||
                    permissionsData.dashboard.totalOrder.edit ||
                    permissionsData.dashboard.totalOrder.read ||
                    permissionsData.dashboard.totalOrder.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`/${subdoamin}/dashboard/total-order`}
                    >
                      <li className="mx-2">Total Orders</li>
                    </Link>
                  )}
              </SidebarItem>
            )}

            {/* Products */}
            {permissionsData?.product?.products &&
              (permissionsData.product.products.create ||
                permissionsData.product.products.edit ||
                permissionsData.product.products.read ||
                permissionsData.product.products.delete) && (
                <Nav.Item as="li" className="sidebar-item ml-auto p-0">
                  <Nav.Link
                    as={Link}
                    to={`/${subdoamin}/products`}
                    className="d-flex p-2 text-black"
                  >
                    <ShoppingBasketIcon className="sidebar-icon me-2" />
                    <span className="sidebar-text my-auto">Products</span>
                  </Nav.Link>
                </Nav.Item>
              )}

            {/* Coupons */}
            {permissionsData?.coupon?.coupons &&
              (permissionsData.coupon.coupons.create ||
                permissionsData.coupon.coupons.edit ||
                permissionsData.coupon.coupons.read ||
                permissionsData.coupon.coupons.delete) && (
                <Nav.Item as="li" className="sidebar-item ml-auto p-0">
                  <Nav.Link as={Link} to={`/${subdoamin}/coupons`} className="p-2 text-black">
                    <LocalOfferIcon className="sidebar-icon me-2" />
                    <span className="sidebar-text">Coupons</span>
                  </Nav.Link>
                </Nav.Item>
              )}

            {/* Shipping */}
            {permissionsData?.shipping?.shipping &&
              (permissionsData.shipping.shipping.create ||
                permissionsData.shipping.shipping.edit ||
                permissionsData.shipping.shipping.read ||
                permissionsData.shipping.shipping.delete) && (
                <Nav.Item as="li" className="sidebar-item ml-auto p-0">
                  <Nav.Link as={Link} to={`/${subdoamin}/shipping`} className="p-2 text-black">
                    <LocalShippingIcon className="sidebar-icon me-2" />
                    <span className="sidebar-text">Shipping</span>
                  </Nav.Link>
                </Nav.Item>
              )}

            {/* Master dropdown */}
            {hasAnyPermission("master") && (
              <SidebarItem
                icon={<SettingsApplicationsIcon className="sidebar-icon" />}
                text="Master"
              >
                {permissionsData.master.category &&
                  (permissionsData.master.category.create ||
                    permissionsData.master.category.edit ||
                    permissionsData.master.category.read ||
                    permissionsData.master.category.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`/${subdoamin}/master/category`}
                    >
                      <li className="mx-2">Category</li>
                    </Link>
                  )}
                {permissionsData.master.subCategory &&
                  (permissionsData.master.subCategory.create ||
                    permissionsData.master.subCategory.edit ||
                    permissionsData.master.subCategory.read ||
                    permissionsData.master.subCategory.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`/${subdoamin}/master/sub-category`}
                    >
                      <li className="mx-2">Sub Category</li>
                    </Link>
                  )}
                {permissionsData.master.blog &&
                  (permissionsData.master.blog.create ||
                    permissionsData.master.blog.edit ||
                    permissionsData.master.blog.read ||
                    permissionsData.master.blog.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`/${subdoamin}/master/blog`}
                    >
                      <li className="mx-2">Blog</li>
                    </Link>
                  )}
                {permissionsData.master.description &&
                  (permissionsData.master.description.create ||
                    permissionsData.master.description.edit ||
                    permissionsData.master.description.read ||
                    permissionsData.master.description.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`/${subdoamin}/master/description-name`}
                    >
                      <li className="mx-2">Description Name</li>
                    </Link>
                  )}
                {permissionsData.master.descriptionType &&
                  (permissionsData.master.descriptionType.create ||
                    permissionsData.master.descriptionType.edit ||
                    permissionsData.master.descriptionType.read ||
                    permissionsData.master.descriptionType.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`/${subdoamin}/master/description-type`}
                    >
                      <li className="mx-2">Description Type</li>
                    </Link>
                  )}


                {permissionsData.master.filter &&
                  (permissionsData.master.filter.create ||
                    permissionsData.master.filter.edit ||
                    permissionsData.master.filter.read ||
                    permissionsData.master.filter.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`/${subdoamin}/master/filter`}
                    >
                      <li className="mx-2">Filter</li>
                    </Link>
                  )}
                {permissionsData.master.filterType &&
                  (permissionsData.master.filterType.create ||
                    permissionsData.master.filterType.edit ||
                    permissionsData.master.filterType.read ||
                    permissionsData.master.filterType.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`${subdoamin}/master/filter-type`}
                    >
                      <li className="mx-2">Filter Type</li>
                    </Link>
                  )}
                {permissionsData.master.offerPoster &&
                  (permissionsData.master.offerPoster.create ||
                    permissionsData.master.offerPoster.edit ||
                    permissionsData.master.offerPoster.read ||
                    permissionsData.master.offerPoster.delete) && (
                    <Link
                      className="text-dark text-decoration-none"
                      style={{ fontSize: "13px" }}
                      to={`${subdoamin}/master/offer-poster`}
                    >
                      <li className="mx-2">Offer Poster</li>
                    </Link>
                  )}
              </SidebarItem>
            )}
          </>
        ) : (
          <>
            <DashBoardIteams />
            <ProductsItems />
            <CouponItems />
            <ShippingItems />
            <MasterItems />
            <VendorItems />

          </>
        )}
      </Nav>
    </div>
  );
};

export default Sidebar;
